/**
 * Lightweight stopwatch for measuring multi-step durations.
 *
 * Usage:
 *   const timer = new AnalyticsTimer()
 *   timer.mark('downloading-python')
 *   // ... time passes ...
 *   timer.mark('installing-packages')  // auto-completes previous mark
 *   timer.complete()
 *   timer.durations  // { 'downloading-python': 1234, 'installing-packages': 567 }
 *   timer.totalMs    // 1801
 */
export class AnalyticsTimer {
  private marks = new Map<string, number>()
  private order: string[] = []
  private startTime = performance.now()
  private endTime: number | null = null

  mark(phase: string): void {
    this.marks.set(phase, performance.now())
    this.order.push(phase)
  }

  complete(): void {
    this.endTime = performance.now()
  }

  get durations(): Record<string, number> {
    const result: Record<string, number> = {}
    for (let i = 0; i < this.order.length; i++) {
      const phase = this.order[i]
      const start = this.marks.get(phase)!
      const end =
        i < this.order.length - 1
          ? this.marks.get(this.order[i + 1])!
          : (this.endTime ?? performance.now())
      result[phase] = Math.round(end - start)
    }
    return result
  }

  get totalMs(): number {
    return Math.round((this.endTime ?? performance.now()) - this.startTime)
  }
}
